import { FC, memo } from 'react';

import { useIsFieldVisible } from './hooks/useIsFieldVisible';
import { FieldVisibilityProps } from './types/FieldVisibilityProps';

// Mirrors `DisplayWhen` from the user-journey renderer. Kept separate for now
// because evaluatables are still coupled to `workflowController` (a UJ/BP
// concern); once that is decoupled this should fold into `DisplayWhen` and
// `conditionalVisibility` can become an `Evaluatable`.
const FieldVisibilityComponent: FC<FieldVisibilityProps> = ({
  field,
  children,
}) => {
  const isVisible = useIsFieldVisible(field);

  return <>{isVisible && children}</>;
};

export const FieldVisibility = memo(FieldVisibilityComponent);
